import type { RouteObject } from 'react-router-dom';
import { PERMISSIONS } from '@shared/constants/permissions';
import { lazyPage } from '@shared/router/lazy-page';
import { PATHS } from '@/router/paths';

/**
 * Payroll routes. Each guard uses the key the BACKEND requires: `GET /payroll`,
 * the payment records and their transactions check `payroll.view` (writes:
 * `payroll.manage`); the compensation structures and the adjustments check
 * `compensation.view` (writes: `compensation.manage`).
 *
 * There is no payroll report screen: the backend publishes no payroll report
 * endpoint, so none is offered.
 */
export const payrollRoutes: RouteObject[] = [
  lazyPage(PATHS.app.payroll, async () => (await import('./overview-page')).PayrollOverviewPage, {
    permission: PERMISSIONS.payroll.view,
  }),
  lazyPage(PATHS.app.payrollRuns, async () => (await import('./runs-page')).PayrollRunsPage, {
    permission: PERMISSIONS.payroll.view,
  }),
  lazyPage(
    PATHS.app.payrollCompensation,
    async () => (await import('./compensation-page')).PayrollCompensationPage,
    { permission: PERMISSIONS.compensation.view },
  ),
  lazyPage(PATHS.app.payrollPayments, async () => (await import('./payments-page')).PayrollPaymentsPage, {
    permission: PERMISSIONS.payroll.view,
  }),
  lazyPage(
    PATHS.app.payrollAdjustments,
    async () => (await import('./adjustments-page')).PayrollAdjustmentsPage,
    { permission: PERMISSIONS.compensation.view },
  ),
];
